import { Container } from "../../styles/global";
import { Login } from "./Login/Login";


export function LoginRegister() {
    return (
        <Container>
            <Login />
        </Container>
    )
}